var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.href ? 'a' : 'button',_vm._g({tag:"component",class:_vm.noReset ? null : 'base-button-reset',attrs:{"href":_vm.href}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }